<template>
  <div>
    <AdButton v-if="userIsProjectAuthor" type="add" fab small :hint="$t('add-actor')" @click="newAuthorStart"/>
    <v-dialog v-model="dialog" width="800" persistent>
      <v-card>
        <AdCardTitle dialog>{{ mode === 'create' ? $t('add-actor') : $t('actor') }}</AdCardTitle>
        <v-card-text class="pa-5">
          <v-form
            ref="authorRef"
            v-if="dialog"
          >
            <EditableDropdown
              v-model="actor.type"
              ref="type"
              :required="rulesActor.requiredAttributes.includes('type')"
              :rules="rulesActor.type"
              :label="$t('type')"
              :items="scenarioActorTypes"
              item-key="value"
              item-text="label"
            />
            <EditableTranslationEditor
              v-model="actor.name"
              ref="name"
              :required="rulesActor.requiredAttributes.includes('name')"
              :rules="rulesActor.name"
              :locales="projectLocales"
              :label="$t('name')"
            />
            <EditableTranslationEditor
              v-model="actor.desc"
              ref="desc"
              :required="rulesActor.requiredAttributes.includes('desc')"
              :locales="projectLocales"
              :label="$t('description')"
            />
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <AdButton type="cancel" color="grey" @click="close"/>
          <AdButton
            :type="(mode === 'create') ? 'add' : 'save'"
            :text="mode === 'create' ? $t('add') : $t('save')"
            @click="save"
          />
        </v-card-actions>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import actor from '@/models/actor'
import rulesActor from '@/rules/actor'
import { cloneDeep } from 'lodash'

export default {
  name: 'ActorFormDialog',
  data () {
    return {
      actor: cloneDeep(actor),
      dialog: false,
      rulesActor
    }
  },
  computed: {
    scenarioActorTypes () {
      return this.$store.getters['server/getScenarioActorTypes']
    },

    mode () {
      return this.actor?.id == null ? 'create' : 'edit'
    }
  },
  methods: {
    newAuthorStart () {
      this.dialog = true
    },
    close () {
      this.dialog = false
      this.reset()
    },
    open (item) {
      this.actor = cloneDeep(item)
      this.$nextTick(() => {
        this.dialog = true
      })
    },
    async save () {
      if (!this.userIsProjectAuthor) {
        this.$alert(this.$t('prohibited'))
        return false
      }
      if (this.$refs.authorRef.validate()) {
        return this.$store.dispatch('scenario/saveActor', this.actor)
          .then(() => {
            if (this.mode === 'create') {
              this.$notify(this.$t('submission-insert-success-label'), 'success')
            } else {
              this.$notify(this.$t('submission-update-success-label'), 'success')
            }
            this.close()
          })
          .catch((error) => {
            this.close()
            const errorMessage = error?.response?.data?.description || error?.response?.statusText || error || 'Error'
            this.$alert(errorMessage)
          })
      } else {
        const hasError = rulesActor.requiredAttributes.filter(attr => this.$refs[attr]?.hasError)
        if (hasError && hasError[0] && this.$refs[hasError[0]]) {
          this.$nextTick(() => {
            this.$refs[hasError[0]].focus()
          })
        }
      }
    },
    reset () {
      this.actor = cloneDeep(actor)
    }
  }
}
</script>

<style lang="scss" scoped>
.v-btn.v-btn--disabled {
  background-color: initial;
}

.headline {
  background: var(--v-topbottomstrip-base);
}
</style>
